var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 55C44.307 55 55.5 43.807 55.5 30C55.5 16.1929 44.307 5 30.5 5C16.6929 5 5.5 16.1929 5.5 30C5.5 43.807 16.6929 55 30.5 55Z",
    fill: "#FDB813"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0342 32.6475L27.2337 39.6145C25.3343 40.736 23 39.2763 23 36.967V23.0329C23 20.7237 25.3343 19.264 27.2337 20.3855L39.0342 27.3525C40.9885 28.5065 40.9885 31.4935 39.0342 32.6475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/PlayIcon.735db260291b5ed38125902b19895c1d.svg";
export { ForwardRef as ReactComponent };